import React from 'react'
import ModalSelectScheduleNotification from './ModalSelectScheduleNotification/ModalSelectScheduleNotification'
import { FrecuencyNotificationId, ScheduleFrecuency } from '../CreateScheduleNotificationForm/CreateScheduleNotificationForm'
import { Schedule } from '../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice'

type ConModalSelectScheduleNotificationProps = {
    schedule?: Schedule
    frecuencyId: FrecuencyNotificationId
    onCloseModal: () => void
    onSet: (schedule: ScheduleFrecuency) => void
}

const ConModalSelectScheduleNotification = ({
    schedule,
    frecuencyId,
    onCloseModal,
    onSet
}: ConModalSelectScheduleNotificationProps) => {

    const handleClickOutsideModal = (e: any) => {
        const clickOutsideModal = document.getElementById("background-aux-modal")?.contains(e.target);
        if(!clickOutsideModal && e.target.id === "darkened-background-modal"){
            //dispatch( setShowJobModalRequestReducer(false) )
            onCloseModal()
        }
            
    }
  
    return (
        <>
            {
                <div onClick={(e) => { handleClickOutsideModal(e) }} id={"darkened-background-modal"} className="background-gray center">
                    <div id={"background-aux-modal"}>
                          <ModalSelectScheduleNotification
                              frecuencyId={frecuencyId}
                              onSet={onSet}
                              onCloseModal={onCloseModal}
                              schedule={schedule}
                          />
                    </div>
                </div>
            }
        </>
    )
}

export default React.memo( ConModalSelectScheduleNotification )